import { useEffect, useState } from "react";

export const useMediaQuery = (
  query: string,
): [boolean, { loading: boolean }] => {
  const [loading, setLoading] = useState(true);
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);

    setLoading(false);
    setMatches(mql.matches);

    const handleChange = () => setMatches(mql.matches);

    mql.addEventListener("change", handleChange);
    window.addEventListener("resize", handleChange);

    return () => {
      mql.removeEventListener("change", handleChange);
      window.removeEventListener("resize", handleChange);
    };
  }, [query]);

  return [matches, { loading: loading }];
};
